import React, { useEffect } from "react";
import {
  I2cInput,
  I2cRadioGroup,
  I2cRadioButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import "../Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
const ACH = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    ov_ach_use_odfi: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    ov_ach_odfi: Yup.string().when("ov_ach_use_odfi", {
      is: (use_odfi) => use_odfi === "no",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    ov_ach_bank: Yup.string().when("ov_ach_use_odfi", {
      is: (use_odfi) => use_odfi === "no",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    ov_ach_account: Yup.string().when("ov_ach_use_odfi", {
      is: (use_odfi) => use_odfi === "no",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    ov_ach_routing: Yup.string().when("ov_ach_use_odfi", {
      is: (use_odfi) => use_odfi === "no",
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      ov_ach_use_odfi: "",
      ov_ach_odfi: "",
      ov_ach_bank: "",
      ov_ach_account: "",
      ov_ach_routing: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "ov_ach_use_odfi",
    "ov_ach_odfi",
    "ov_ach_bank",
    "ov_ach_account",
    "ov_ach_routing",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[6]["6_7"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      6: {
        ...addFormData["6"],
        "6_7": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_7", true);
    else setFormValidStates("6_7", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="sub-heading mb-16">
              Would you like to use i2c Inc's default ODFI Institute/Services?
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="ov_ach_use_odfi"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("ov_ach_use_odfi")}
                    {...field}
                    name="ov_ach_use_odfi"
                    onI2cChange={(e) => {
                      [
                        "ov_ach_odfi",
                        "ov_ach_bank",
                        "ov_ach_account",
                        "ov_ach_routing",
                      ].map((field) => methods.setValue(field, ""));
                      field.onChange(e);
                      handleValueChanges();
                      methods.trigger();
                    }}
                  >
                    {["Yes", "No"].map((radio, index) => (
                      <I2cRadioButton
                        key={index}
                        value={radio.toLocaleLowerCase()}
                      >
                        {radio}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("ov_ach_use_odfi") === "no" && (
            <React.Fragment>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_odfi"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        required
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="ODFI institute"
                        name={"ov_ach_odfi"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_odfi &&
                      methods.formState.touchedFields.ov_ach_odfi
                        ? true
                        : false
                    }
                    message={errors.ov_ach_odfi?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_bank"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        required
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Settlement Bank"
                        name={"ov_ach_bank"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_bank &&
                      methods.formState.touchedFields.ov_ach_bank
                        ? true
                        : false
                    }
                    message={errors.ov_ach_bank?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_account"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        required
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Settlement Account"
                        name={"ov_ach_account"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_account &&
                      methods.formState.touchedFields.ov_ach_account
                        ? true
                        : false
                    }
                    message={errors.ov_ach_account?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="ov_ach_routing"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        required
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Settlement Routing #"
                        name={"ov_ach_routing"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.ov_ach_routing &&
                      methods.formState.touchedFields.ov_ach_routing
                        ? true
                        : false
                    }
                    message={errors.ov_ach_routing?.message ?? "Invalid input"}
                  /> */}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default ACH;
